import { c as _c } from "react/compiler-runtime";
import { Details } from '@cc-shopping/ui/primitives/Details';
import { palette } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useId } from 'react';
const ACCORDION_BORDER_RADIUS = '16px';
export type LeftNavMobileAccordionProps = {
  ordered: boolean | null;
  labels: string[];
  renderedContents: ReactNode[];
};
export const LeftNavMobileAccordion = t0 => {
  const $ = _c(12);
  const {
    ordered,
    labels,
    renderedContents
  } = t0;
  const idSuffix = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginY: 3,
      display: {
        sm: "none"
      },
      border: "1px solid",
      borderColor: "neutral.lighter",
      borderRadius: ACCORDION_BORDER_RADIUS
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== idSuffix || $[2] !== labels || $[3] !== ordered || $[4] !== renderedContents) {
    let t3;
    if ($[6] !== idSuffix || $[7] !== ordered || $[8] !== renderedContents) {
      t3 = (label, index) => {
        const contentId = `left-nav-panel-content-mobile-${index}-${idSuffix}`;
        return <Details key={`accordion-item-${label}`} variant="simple" SummaryComponent={<Box component="span" sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}><Box component="span" sx={{
            display: "flex",
            alignItems: "center",
            gap: 3
          }}>{ordered && <Box component="span" sx={{
              backgroundColor: "greens.lightest",
              minWidth: "35px",
              minHeight: "35px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}><Typography variant="smallHeadline">{index + 1}</Typography></Box>}<Typography component="span" variant="smallHeadline" role="heading" aria-level={3}>{label}</Typography></Box><span className="mask-icon mask-icon-expand-more expand-icon" style={{
            width: "24px",
            height: "24px",
            backgroundColor: palette.common.black
          }} /></Box>} summaryComponentProps={{
          "aria-controls": contentId,
          sx: {
            paddingY: "12px",
            paddingX: 3
          }
        }} detailsProps={{
          sx: {
            "&:not(:last-of-type)": {
              borderBottom: "1px solid",
              borderColor: "neutral.lighter"
            },
            "&> summary:hover": {
              backgroundColor: "blues.lightest",
              outline: "2px solid",
              outlineColor: "blues.light"
            },
            "&:first-of-type": {
              "&> summary:hover": {
                borderTopLeftRadius: ACCORDION_BORDER_RADIUS,
                borderTopRightRadius: ACCORDION_BORDER_RADIUS
              }
            },
            "&:last-of-type": {
              "&> summary:hover": {
                borderBottomLeftRadius: ACCORDION_BORDER_RADIUS,
                borderBottomRightRadius: ACCORDION_BORDER_RADIUS
              }
            },
            "&[open]": {
              "&> summary:hover": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
              }
            }
          }
        }}><Box id={contentId} sx={{
            padding: 3
          }}>{renderedContents[index]}</Box></Details>;
      };
      $[6] = idSuffix;
      $[7] = ordered;
      $[8] = renderedContents;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = labels.map(t3);
    $[1] = idSuffix;
    $[2] = labels;
    $[3] = ordered;
    $[4] = renderedContents;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <Box data-testid="credit-cards-left-nav-mobile" sx={t1}>{t2}</Box>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};